import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowRight, ArrowLeft } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="forgot-password-page" className="min-h-screen flex items-center justify-center bg-alabaster px-6 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <p className="overline mb-3">RECUPERAÇÃO DE ACESSO</p>
          <h1 className="font-serif text-4xl text-onyx">Esqueceu Sua Senha?</h1>
          <p className="mt-3 text-onyx/60 text-sm">
            Informe seu e-mail e enviaremos um link para redefinir sua senha.
          </p>
        </div>

        {sent ? (
          <div data-testid="forgot-password-sent" className="bg-white border border-border p-8 text-center">
            <p className="font-serif text-2xl text-onyx mb-2">Verifique seu e-mail</p>
            <p className="text-sm text-onyx/60">
              Se o e-mail existir no nosso sistema, você receberá um link para redefinir sua senha.
            </p>
            <p className="mt-4 text-xs text-onyx/40">
              Dica: em ambiente de teste sem provedor de e-mail configurado, o link aparece nos logs do backend e pode ser copiado em <code className="text-gold">Admin → Configurações → Último link de reset</code>.
            </p>
          </div>
        ) : (
          <form data-testid="forgot-password-form" onSubmit={onSubmit} className="bg-white border border-border p-8 space-y-5">
            <div>
              <label className="block text-xs tracking-[0.2em] uppercase text-onyx/60 mb-2">E-mail</label>
              <div className="relative">
                <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-onyx/40" />
                <input
                  data-testid="forgot-email-input"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-3 py-3 border border-border bg-alabaster text-onyx focus:outline-none focus:border-gold text-sm"
                  placeholder="seu@email.com"
                />
              </div>
            </div>
            {error && <p data-testid="forgot-error" className="text-sm text-destructive">{error}</p>}
            <button
              type="submit"
              disabled={submitting}
              data-testid="forgot-submit"
              className="w-full inline-flex items-center justify-center gap-3 py-3.5 bg-onyx text-alabaster text-xs tracking-[0.25em] uppercase font-semibold hover:bg-gold hover:text-onyx transition-colors disabled:opacity-50"
            >
              {submitting ? "Enviando…" : "Enviar Link"}
              <ArrowRight size={14} />
            </button>
          </form>
        )}

        <p className="mt-6 text-center text-xs text-onyx/40">
          <Link to="/admin/login" data-testid="forgot-back-to-login" className="hover:text-gold inline-flex items-center gap-1">
            <ArrowLeft size={12} /> Voltar para login
          </Link>
        </p>
      </div>
    </div>
  );
}
